import { WagmiProvider } from 'wagmi';
import { QueryClientProvider } from '@tanstack/react-query';
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';
import { createConfig, http } from 'wagmi';
import { mainnet } from 'wagmi/chains';
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
    metaMaskWallet,
    coinbaseWallet,
    walletConnectWallet,
    rainbowWallet,
    okxWallet,
    zerionWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { queryClient } from '@/lib/query/queryClient';

const projectId = '68436629af4975f2644b24fd0f63e86f';
const connectors = connectorsForWallets(
    [
        {
            groupName: 'Recommended',
            wallets: [
                // toPrivyWallet({
                //     id: 'cmc25921q01izle0ms5iojge4',
                //     name: 'BasedApp',
                //     iconUrl: 'https://basedapp.io/app-icons/appicon.png',
                // }),
                metaMaskWallet,
                coinbaseWallet,
                walletConnectWallet,
                rainbowWallet,
                okxWallet,
                zerionWallet,
            ],
        },
    ],
    {
        appName: 'CMM',
        projectId,
    },
);

const config = createConfig({
    chains: [mainnet],
    connectors,
    transports: {
        [mainnet.id]: http(),
    },
});

const WagmiContext = ({ children }) => {
    return (
        <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
                <RainbowKitProvider
                    theme={darkTheme({
                        accentColor: '#15C8B1',
                        fontStack: 'system',
                    })}
                    appInfo={{
                        appName: 'HyperTracker',
                        disclaimer: () => null,
                    }}
                >
                    {children}
                </RainbowKitProvider>
            </QueryClientProvider>
        </WagmiProvider>
    );
};

export default WagmiContext;
